import { DreFormComp, DreListComp } from './components';

import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { DreFormProvider, DreListProvider } from 'pages/financeiro/dre/contexts';

export function DreForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['FINANCEIRO_DRE_PREENCHER'])) return alertNotPermission();

    return (
        <DreFormProvider>
            <DreFormComp />
        </DreFormProvider>
    );
}

export function DreList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['FINANCEIRO_DRE_VISUALIZAR'])) return alertNotPermission();

    return (
        <DreListProvider>
            <ListagemProvider>
                <DreListComp />
            </ListagemProvider>
        </DreListProvider>
    );
}
